module.exports = __webpack_public_path__ + "static/img/200306.4a888bd1.png";